module.exports = __webpack_public_path__ + "img/DE03952.9a4b1dc7.png";